import { COMPLETE, SKIP } from '../../lib/analytics';
// Actions
const NAMESPACE = 'ONBOARDING';
export const CHECK_ONBOARDING = `${NAMESPACE}/CHECK_ONBOARDING`;
export const START_ONBOARDING = `${NAMESPACE}/START_ONBOARDING`;
export const START_TOUR = `${NAMESPACE}/START_TOUR`;
export const START_MULTI_PAGE_TOUR = `${NAMESPACE}/START_MULTI_PAGE_TOUR`;
export const END_TOUR = `${NAMESPACE}/END_TOUR`;
export const SKIP_TOUR = `${NAMESPACE}/SKIP_TOUR`;

/*** Action Creators ***/
export const checkOnboarding = () => ({
  type: CHECK_ONBOARDING
});

export const startOnboarding = (shouldStartOnboarding) => ({
  type: START_ONBOARDING,
  shouldStartOnboarding
});

/**
 * Starts the full product tour.
 */
export const startMultiPageTour = (referrer) => ({
  type: START_MULTI_PAGE_TOUR,
  referrer
});

/**
 * @param {Array|String} tourQueue Expects a tourQueue of one or more tour names.
 *  Tour will run in the order given.
 */
export const startTour = ({ tourQueue }) => {
  if (!tourQueue || !tourQueue.length) {
    throw new Error('Cannot start without specifying one or more tours.');
  }
  return {
    type: START_TOUR,
    tourQueue: Array.isArray(tourQueue) ? tourQueue : [tourQueue]
  };
};

export const endTour = (referrer) => ({
  type: END_TOUR,
  step: referrer,
  introJsAction: COMPLETE
});

export const skipTour = (referrer) => ({
  type: SKIP_TOUR,
  step: referrer,
  introJsAction: SKIP
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  isTourActive: false,
  tourQueue: [],
  // This may likely change in NOV-7106
  shouldStartOnboarding: false
};

export default function OnboardingReducer(
  state = DEFAULT_STATE,
  { type, tourQueue, shouldStartOnboarding } = {}
) {
  switch (type) {
    case START_TOUR:
      return {
        ...state,
        tourQueue: [...tourQueue],
        isTourActive: true,
        shouldStartOnboarding: false
      };
    case END_TOUR:
    case SKIP_TOUR:
      return {
        ...state,
        tourQueue: [],
        isTourActive: false,
        shouldStartOnboarding: false
      };
    case START_ONBOARDING:
      return {
        ...state,
        shouldStartOnboarding
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/onboarding/onboardingActions.js